import { GlobalConfig } from "./global-config.model"

export class Company {
    public id?: number
    public name?: string
    public description?: string
    public status?:boolean
    public globalConfig?:GlobalConfig
    public globalConfigId?:number
}